import React, { useState, useEffect } from "react";
import Header from "../components/home/header";
import Sidebar from "../components/home/sidebar";
import ErrorContainer from "../components/home/four";

function Errorpage() {
  const [displaySidebar, setDisplaySidebar] = useState(false);

  function changeSidebarDisplay() {
    setDisplaySidebar((prev) => !prev);
  }

 
  useEffect(() => {
      document.body.style.overflow = "hidden"; 
  
      return () => {
        document.body.style.overflow = "auto"; 
      };
    }, []);

  return (
    <div className="w-full   bg-[#202020] flex flex-col pt-4 sm:pt-6 overflow-hidden">
      <Header sidebarDisplay={displaySidebar} changeSidebarDisplay={changeSidebarDisplay} />
      <main className="flex flex-grow relative">
        <Sidebar sidebarDisplay={displaySidebar} />
        <ErrorContainer />
      </main>
    </div>
  );
}

export default Errorpage;
